var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":_vm.dark}},[_c('l-global',{attrs:{"right":"","top":""}}),_c('l-exit-dialog'),_c('l-slide-y-enter-transition',[_c('keep-alive',{attrs:{"include":_vm.catchList}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }